const getCurrentTime = (): Date => {
    return new Date()
}
const formatDate = (time: Date | number | string, format: string): string | null=> {
    const now = new Date();
    const date = new Date(time);

    if(!time) {
        return null
    }

    if (format === '人性化') {
        // 人性化格式使用本地时间，方便做"今天/昨天"判断
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const diff = now.getTime() - date.getTime();
        const diffHours = Math.floor(diff / (1000 * 60 * 60));
        // 今天
        if (diffHours < 24 && now.getDate() === date.getDate()) {
            return `今天 ${hours}:${minutes}`;
        }
        // 昨天
        else if (diffHours < 48 && now.getDate() - date.getDate() === 1) {
            return `昨天 ${hours}:${minutes}`;
        }
        // 更早（今年）
        else if (now.getFullYear() === date.getFullYear()) {
            return `${month}-${day} ${hours}:${minutes}`;
        }
        // 去年
        else {
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        }
    }

    // 对于 Y-m-d / Y-m-d H:i:s 等格式化输出，使用 UTC 方法
    // 避免因用户所在时区不同导致日期偏移（如 UTC-5 用户看到 1989-12-31 而不是 1990-01-01）
    const year = date.getUTCFullYear().toString();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const day = date.getUTCDate().toString().padStart(2, "0");
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");

    const formatMap: { [key: string]: string } = {
        Y: year,
        m: month,
        d: day,
        H: hours,
        i: minutes,
        s: seconds
    };
    return format.replace(/[YmdHis]/g, (match) => {
        return formatMap[match];
    });
}
const isDiffDate = (date1: Date | string, date2: Date | string, diff: number): boolean => {
    if(typeof date1 === 'string') {
        date1 = new Date(date1)
    }
    if(typeof date2 === 'string') {
        date2 = new Date(date2)
    }
    const diffInSeconds = Math.abs(date1.getTime() - date2.getTime()) / 1000;
    const isSameDay = date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
    return diffInSeconds <= diff && isSameDay;
}


export {formatDate, getCurrentTime, isDiffDate}
